import { render, staticRenderFns } from "./OrganismStatementsSlider.vue?vue&type=template&id=15eebf99&"
import script from "./OrganismStatementsSlider.vue?vue&type=script&lang=js&"
export * from "./OrganismStatementsSlider.vue?vue&type=script&lang=js&"
import style0 from "./OrganismStatementsSlider.vue?vue&type=style&index=0&id=15eebf99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonSliderAtomStatementsSlider: require('/app/components/atoms/common/slider/AtomStatementsSlider.vue').default,MoleculesCommonMoleculeStatementsSlider: require('/app/components/molecules/common/MoleculeStatementsSlider.vue').default})
